import React from 'react';
import styled from 'styled-components';
import { useTheme } from '../contexts/ThemeContext';
import { FaEnvelope } from 'react-icons/fa';
import usePageTitle from '../hooks/usePageTitle';
import PageMeta from '../components/SEO/PageMeta';

const CONTACT_EMAIL = 'cx@slickpicks.bet';

const Container = styled.div`
  max-width: 600px;
  margin: 0 auto;
  padding: 2rem 1rem;
  min-height: 60vh;
`;

const Title = styled.h1`
  font-size: 2rem;
  font-weight: 700;
  color: ${(props) => props.theme.primaryText};
  text-align: center;
  margin-bottom: 0.5rem;
`;

const Subtitle = styled.p`
  font-size: 1.1rem;
  color: ${(props) => props.theme.secondaryText};
  text-align: center;
  margin-bottom: 2rem;
  line-height: 1.5;
`;

const Card = styled.div`
  background: ${(props) => props.theme.cardBg};
  border-radius: 0.5rem;
  padding: 2rem;
  box-shadow: ${(props) => props.theme.shadow};
  border: 1px solid ${(props) => props.theme.border};
  text-align: center;
`;

const EmailLabel = styled.span`
  display: block;
  font-size: 0.875rem;
  color: ${(props) => props.theme.secondaryText};
  margin-bottom: 0.5rem;
`;

const EmailLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1.25rem;
  font-weight: 600;
  color: ${(props) => props.theme.primary};
  text-decoration: none;
  word-break: break-all;
  &:hover {
    text-decoration: underline;
  }
  &:focus {
    outline: 2px solid ${(props) => props.theme.primary};
    outline-offset: 2px;
  }
`;

const ContactPage = () => {
  const { theme } = useTheme();
  usePageTitle('Contact Slick Picks');

  return (
    <Container>
      <PageMeta description="Contact the Slick Picks team with questions, feedback, or support requests about MLB player prop predictions and the product." />
      <Title theme={theme}>Contact Us</Title>
      <Subtitle theme={theme}>
        Questions, feedback, or support? Reach out and we’ll get back to you as soon as we can.
      </Subtitle>
      <Card theme={theme}>
        <EmailLabel theme={theme}>Email</EmailLabel>
        <EmailLink theme={theme} href={`mailto:${CONTACT_EMAIL}`}>
          <FaEnvelope aria-hidden />
          {CONTACT_EMAIL}
        </EmailLink>
      </Card>
    </Container>
  );
};

export default ContactPage;
